import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-two-columns",
  templateUrl: "./med-icon-view-two-columns.component.html",
})
export class MedIconViewTwoColumnsComponent extends SvgMixinComponent {}
